import { SafeDictionary } from "@insite/client-framework/Common/Types";
import { Handler, HasOnSuccess, replaceInChain } from "@insite/client-framework/HandlerCreator";
import siteMessage from "@insite/client-framework/SiteMessage";
import { chain, ValidateCity, ValidateState } from "@insite/client-framework/Store/CommonHandlers/ValidateAddress";
import { getCurrentCountries } from "@insite/client-framework/Store/Data/Countries/CountriesSelectors";
import translate from "@insite/client-framework/Translate";
import {
    AddressFieldDisplayCollectionModel,
    AddressFieldDisplayModel,
    BaseAddressModel,
    CustomerValidationDto,
} from "@insite/client-framework/Types/ApiModels";

export type AddressErrors = SafeDictionary<React.ReactNode>;

type HandlerType = Handler<
    {
        address: BaseAddressModel;
        validationRules: CustomerValidationDto;
        addressFieldDisplayCollection: AddressFieldDisplayCollectionModel;
    } & HasOnSuccess<AddressErrors>,
    {
        addressErrors: AddressErrors;
    }
>;
const isEmpty = (value: string) => value.trim().length <= 0;

const getRequiredErrorMessage = (addressFieldDisplayCollection: AddressFieldDisplayModel) =>
    siteMessage("Field_Required", addressFieldDisplayCollection.displayName);

export const ResetFormErrors: HandlerType = props => {
    props.addressErrors = {};
};


export const ValidateStateExtended: HandlerType = props => {
    const { country, state } = props.parameter.address;
    const { addressFieldDisplayCollection } = props.parameter;
    const countries = getCurrentCountries(props.getState());
    if (!countries) {
        throw new Error("Cannot validate country. The website countries have not been loaded yet.");
    }

    if (!country) {
        // This is fine to simply return because the address country
        // is validated in the previous handler. If the country has not
        // been selected yet, it doesn"t make sense to show an error for the state.
        return;
    }

    const countryLookup = countries.find(c => c.id === country.id);
    const currentCountry = country?.name === "United States";
    if (
        countries.length > 0 &&
        countryLookup?.states &&
        !state &&
        currentCountry &&
        addressFieldDisplayCollection.state
    ) {
        props.addressErrors.state = getRequiredErrorMessage(addressFieldDisplayCollection.state);
    } 
};

replaceInChain(chain, ValidateState, ValidateStateExtended);

export const ValidateCityExtended: HandlerType = props => {
    const { validationRules, addressFieldDisplayCollection } = props.parameter;
    const { city, country } = props.parameter.address;
    if (addressFieldDisplayCollection.city?.isVisible && validationRules.city?.isRequired && isEmpty(city)) {
        props.addressErrors.city = getRequiredErrorMessage(addressFieldDisplayCollection.city);
    }
    if((country?.abbreviation === "US" && city.indexOf(",") !== -1)) {
        props.addressErrors.city = translate("Please verify that only the city is filled in.")
    }
};
replaceInChain(chain, ValidateCity, ValidateCityExtended);